import { Card, Title, Text, Badge, Button, Group, Stack } from "@mantine/core";
import { IconDownload, IconChartBar } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { formatDateTime, HighlightList } from "./TournamentsPage";
import { DemoMatch } from "@/types/demos";
import { buildDemoDownloadUrl } from "@/services/demoMatchesService";
import { getDisplayName } from "@/utils/demoUtils";

export const DemoDownloadCard: React.FC<{ match: DemoMatch }> = ({ match }) => {
    const [teamA, teamB] = match.teams;
    const navigate = useNavigate();

    return (
        <Card shadow="sm" padding="lg" radius="md" withBorder>
            <Stack gap="xs">
                <Title order={4}>{match.event}</Title>
                <Text size="sm" c="dimmed">
                    {match.stage} · {formatDateTime(match.playedAt)} · {match.map} · BO{match.bestOf}
                </Text>
                <Group gap="xs">
                    <Text>
                        <strong>
                            {teamA.name} ({teamA.score})
                        </strong>{' '}
                        vs{' '}
                        <strong>
                            {teamB.name} ({teamB.score})
                        </strong>
                    </Text>
                    <Badge color="violet" size="sm" radius="sm">
                        {match.fileSizeMB.toFixed(1)} MB
                    </Badge>
                </Group>
                <HighlightList match={match} />
                {match.notes && <Text size="sm">{match.notes}</Text>}
            </Stack>
            <Card.Section inheritPadding py="md" mt="md" withBorder>
                <Group justify="center" gap="sm">
                    <Button
                        component="a"
                        href={buildDemoDownloadUrl(match.id)}
                        target="_blank"
                        rel="noreferrer"
                        download={getDisplayName(match)}
                        leftSection={<IconDownload size={16} />}
                        color="violet"
                    >
                        Lataa demo
                    </Button>
                    <Button
                        variant="light"
                        leftSection={<IconChartBar size={16} />}
                        onClick={() => navigate(`/analytics/${match.id}`)}
                    >
                        Analytiikka
                    </Button>
                </Group>
            </Card.Section>
        </Card>
    );
};